import { render, staticRenderFns } from "./likebutton.vue?vue&type=template&id=9ccd98ca&"
import script from "./likebutton.vue?vue&type=script&lang=js&"
export * from "./likebutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports